export default __webpack_public_path__ + "static/media/img10.95e7f3fc.jpg";